import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./AuthDrawer.css";

class ForgotPasswordOne extends Component {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      email: "",
    };
  }

  handleChange(event) {
    this.setState({
      email: event.target.value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    this
      .props
      .authDrawerActions
      .requestPasswordReset(this.state.email)
      .then(() => {
        this.setState({
          email: "",
        });

        this.changeStep(authDrawerConstants.FORGOTPASSWORD2);
      });
  }

  changeStep(step, event) {
    if (event) {
      event.preventDefault();
    }

    this.props.authDrawerActions.changeStep(step);
  }

  render() {
    return (
      <div className={styles.container}>
        <h3>Reset password</h3>

        <div className={styles.marginTop20}>
          Let us know your email address so we can send you a link to reset your password.
        </div>

        <form onSubmit={this.handleSubmit}>
          <div className={styles.marginTop40}>
            <input onChange={this.handleChange} name="email" type="text" placeholder="Email" value={this.state.email} />
          </div>

          <div className={styles.nextButton}>
            <button type="submit" className={classNames(styles.blueButton1, styles.block, styles.centered)}>
              Reset Password
            </button>
          </div>
        </form>

        <div className={classNames(styles.marginTop10, styles.textCenter)}>
          <a onClick={this.changeStep.bind(this, authDrawerConstants.SIGNIN)} href="#" className={classNames(styles.blackLink, styles.bold)}>Cancel</a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordOne);



// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/ForgotPasswordOne.js